module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-laurel-highfive.a47a1c1.png";